export default {
  Signup: {
    TITLE: 'Sign Up',
    BODY: 'Multi-entity bliss is just one step away!',
    NAME: 'Name',
    EMAIL: 'Email address',
    ACCOUNTING: 'Which accounting system do you use?',
    CHOOSE: 'Choose your Accounting System',
    SUBMIT: 'Sign Up',
    SIGN_IN_WITH_XERO: 'Sign up with Xero',
    COMPLETE: 'Thanks for signing up! We\'re building out our accounting system integrations currently, so we\'ll be in touch to let you know when you can start using Mayday',
    ACCOUNT: 'Already have an account?',
    LOG_IN: 'Log in here',
    XERO_USER: 'Xero User?',
    SIGN_UP: 'Click the button below, sign in to Xero, and you\'ll be taken into Mayday.',
    USE_XERO: 'Good news! You can get straight in by signing up with Xero.',
    MORE_INFO: 'How does this work?',
    Register: {
      NOT_XERO: 'Not using Xero?',
      FORM_ERRORS: 'Please check the form for errors.',
      ANOTHER_SYSTEM: 'Using another accounting system?',
      XERO_INTEGRATION: 'We currently only integrate with Xero. But we\'re moving fast! Enter your details below to help us prioritise which accounting system to integrate with next.',
    },
    Products: {
      RECHARGER_INTRO: 'Run your intercompany recharges in 98% less time.',
      BRAG_INTRO: 'Reconcile cross-entity bank transactions without switching Xero files.',
      BALANCER_INTRO: 'Ensure that intercompany loans will never fall out of balance again.',
      MORE_INFO: 'Find out more about {{product}}',
    },
  },
};
